<template>


	<b-container>
		<!--bu page ekan-->
		<b-row class="mb-2">
			<b-col>
				<b-input-group size="sm" class="shadowed-group">
					<b-form-input size="sm" id="color"
								  ref="clientSearchInput"
								  v-model="lastName"
								  autocomplete="off"
								  :placeholder="$t('incomes.search.search')">
					</b-form-input>
					<b-input-group-addon>
						<b-button @click="searchLast">
							<i class="fa fa-search"></i>
						</b-button>
					</b-input-group-addon>
					<b-input-group-addon v-if="lastName">
						<b-button @click="asyncFind">
							<i class="fa fa-close"></i>
						</b-button>
					</b-input-group-addon>
				</b-input-group>
			</b-col>
		</b-row>

		<div class="generalTableClass" style="overflow-y: scroll;max-height: 400px">

			<with-keyboard-control
				:listLength="itemsForSearch.length"
				@selected="selectedHandler"
				:current-index="currentIndex"
				@click="selectedHandler"
			>
				<template slot-scope="{selectedIndex}">
					<table class="table tabled-bordered">
						<thead>
						<tr>
							<th>№</th>
							<th>{{ $t('client.create.first-name') }}</th>
							<th> {{ $t('client.create.last-name') }}</th>
							<th> {{ $t('client.create.middle-name') }}</th>
							<th> {{ $t('client.create.mobile') }}</th>
							<th>{{ $t('client.create.phone') }}</th>
							<th>{{ $t('client.create.email') }}</th>
						</tr>
						</thead>
						<tbody>

						<tr
							v-for="(item, index) in itemsForSearch"
							class="list-item"
							:class="{'selected': index === selectedIndex }"
							:key="item.id">
							<td>
								<!--<b-radio v-bind:value="item" @change="radioChecked" v-model="currentClient"
										 name="clientRadio"></b-radio>-->
								<strong>{{ index }}</strong>
							</td>

							<td> {{ item.firstName }}</td>
							<td> {{ item.lastName }}</td>
							<td> {{ item.middleName }}</td>
							<td> {{ item.mobile }}</td>
							<td> {{ item.phone }}</td>
							<td> {{ item.email }}</td>
						</tr>
						</tbody>
					</table>
				</template>
			</with-keyboard-control>

		</div>
		<!--		<div class="mt-1">-->
		<!--&lt;!&ndash;			<hr>&ndash;&gt;-->

		<!--&lt;!&ndash;			<b-button class="pull-right" variant="primary" @click="chooseClient" size="sm">{{ $t('save') }}&ndash;&gt;-->
		<!--&lt;!&ndash;			</b-button>&ndash;&gt;-->
		<!--		</div>-->
	</b-container>

</template>

<script>
	import ClientService from "../../services/client.service";
	import {mapGetters, mapActions, mapState} from 'vuex'
	import WithKeyboardControl from "./WithKeyboardControl";

	export default {
		name: "ChooseClient",
		components: {
			WithKeyboardControl
		},
		props: {
			currentIndex: Number,
			defaults: {
				type: Array
			}
		},
		data() {
			return {
				name: "bekzod",
				items: [],
				lastName: '',
				checked: true,
				checkedClient: {},
				currentClient: null,
				search: {
					page: 1,
					limit: 10,
					attributes: [
						{
							field: 'lastName',
							value: '',
							option: 'CONTAINS'
						},

					]
				}
			}
		},
		methods: {
			async selectedHandler(selectedIndex) {
				await this.setCurrentClient(this.itemsForSearch[selectedIndex]);

				await this.$emit('close', false, selectedIndex);
			},
			async asyncFind() {
				await this.getAllCLientsForSearchForm(this.search);
				this.lastName = "";
				await this.$refs.clientSearchInput.focus();

			},
			async searchLast() {
				await this.searchLastNameStore(this.lastName);
				this.$emit('resetCurrentIndex');
			},
			...mapActions('clients', [
				'setCurrentClient', 'searchLastNameStore', 'getAllCLientsForSearchForm'
			]),
		},

		async mounted() {
			// this.currentClient = this.getCurrentClient;
			await this.$refs.clientSearchInput.focus();
			/*let index = this.itemsForSearch.findIndex(el => {
				return el.id == this.currentClient.id;
			});*/
		},
		async created() {
			await this.asyncFind();
			await this.getAllCLientsForSearchForm(this.search);
		},
		computed: {
			...mapGetters('clients', [
				'clients', 'getCurrentClient'
			]),
			...mapState('clients', [
				'itemsForSearch',
			]),
		},
		watch: {
			'search.attributes':
				{
					deep: true,
					handler() {
						this.asyncFind();
					}
				},
			'lastName': {
				handler() {
					if (this.lastName == "") {
						this.asyncFind();
					} else {
						this.searchLast();
					}

				}
			}
		}

	}
</script>

<style scoped>


	.list-item {
		width: 150px;
		text-align: center;
		border: 1px solid #999;
		cursor: pointer;
	}

	.list-item:hover,
	.list-item.selected {
		background-color: lightgrey;
	}

	td:first-child {
		border-left: 1px solid #c8ced3;
	}
</style>
